<template>
  <div>
    <span id="poweredBy">By <a href="https://cleed.ai/" target="_BLANK">Cleed.ai</a></span>
  </div>
</template>

<script>

export default {
  name:'PoweredBy',
};
</script>
